const SPOTLIGHTS = [
  {
    title: '诺兰宇宙：时间与空间的诗学',
    desc: '从《记忆碎片》到《星际穿越2》，克里斯托弗·诺兰用二十年的时间构建了一个令人叹为观止的电影宇宙。本专题回顾诺兰导演的全部作品，深入解析其独特的叙事结构和视觉美学。每一部都是烧脑与视觉的双重盛宴。',
    tag: '导演专题',
    tagColor: 'bg-primary-100 text-primary-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20director%20working%20on%20set%20with%20warm%20dramatic%20lighting%20and%20movie%20camera%20equipment%20professional%20atmosphere&width=448&height=300&seq=carousel-1-2026&orientation=landscape',
  },
  {
    title: '国产动画崛起：从大圣到哪吒',
    desc: '中国动画电影正经历前所未有的黄金时代。《大圣归来》《哪吒》《白蛇》等一系列佳作不仅票房屡创新高，更在艺术表达上达到了国际水准。花生影院为你整理国产动画电影大全，见证国漫的华丽蜕变。',
    tag: '行业观察',
    tagColor: 'bg-accent-100 text-accent-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Vibrant%20animated%20Chinese%20mythology%20scene%20with%20colorful%20traditional%20art%20style%20and%20dynamic%20composition%20cinematic%20lighting&width=448&height=300&seq=carousel-2-2026&orientation=landscape',
  },
  {
    title: '午夜影院：胆小慎入的恐怖盛宴',
    desc: '深夜关灯，戴上耳机，准备好迎接心跳加速的恐怖之旅。花生影院「午夜影院」频道精选全球高分恐怖惊悚电影，从日式心理恐怖到美式血浆惊悚，从泰式灵异到韩式悬疑，满足你对恐惧的所有想象。',
    tag: '频道推荐',
    tagColor: 'bg-secondary-200 text-secondary-800',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20horror%20movie%20scene%20with%20moody%20shadows%20and%20warm%20amber%20light%20creating%20tension%20and%20mystery%20cinematic%20composition&width=448&height=300&seq=carousel-3-2026&orientation=landscape',
  },
  {
    title: '奥斯卡十年：最佳影片全回顾',
    desc: '过去十年的奥斯卡最佳影片，每一部都是电影艺术的巅峰代表。从《寄生虫》到《瞬息全宇宙》，这些获奖作品不仅是票房与口碑的双赢，更折射出当代社会的深层思考。花生影院奥斯卡专题，带你品味真正的好电影。',
    tag: '奖项特辑',
    tagColor: 'bg-primary-100 text-primary-700',
    imageUrl:
      'https://readdy.ai/api/search-image?query=Elegant%20golden%20Oscar%20statue%20trophy%20on%20deep%20red%20velvet%20background%20with%20dramatic%20spotlight%20and%20warm%20cinematic%20atmosphere&width=448&height=300&seq=carousel-4-2026&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            焦点推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑精选的深度专题内容，带你深入了解电影世界的精彩
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {SPOTLIGHTS.map((item, i) => (
            <div
              key={i}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-secondary-100/60 hover:border-secondary-300/60 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-48 md:w-56 h-48 sm:h-auto flex-shrink-0 overflow-hidden bg-secondary-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
              </div>
              <div className="flex-1 p-5 md:p-6">
                <span
                  className={`inline-block text-xs px-2.5 py-1 rounded-full font-medium mb-3 ${item.tagColor}`}
                >
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-heading text-foreground-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-4">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-1 text-sm text-primary-600 font-medium">
                  <span>查看专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}